export enum AnalyticEventNames {
    /**
     * @description Посещение лендинга
     */
    QUOTA_LANDING_SHOWN = 'QUOTA_LANDING_SHOWN',
    /**
     * @description Посещение мобильного лендинга с тарифами
     */
    MOBILE_LANDING_SHOWN = 'MOBILE_LANDING_SHOWN',
    /**
     * @description Показ на экране блока тарифов
     */
    TARIFFS_SHOWN = 'TARIFFS_SHOWN',
    /**
     * @description Показ на экране блока тарифа (десктоп)
     */
    TARIFF_SHOWN = 'TARIFF_SHOWN',
    /**
     * @description Показ на экране блока тарифа (мобилка)
     */
    MOBILE_TARIFF_SHOWN = 'MOBILE_TARIFF_SHOWN',
    /**
     * @description  Клик по ссылке возможности на карточке тарифа
     */
    TARIFF_ADVANTAGES_CLICK = 'TARIFF_ADVANTAGES_CLICK',
    /**
     * @description Показ модального окна с возможностями тарифа
     */
    MODAL_TARIFF_ADVANTAGES_SHOW = 'MODAL_TARIFF_ADVANTAGES_SHOW',
    /**
     * @description Клик по конкрентному  тарифу
     */
    TARIFF_CLICK = 'TARIFF_CLICK',

    /** Показа окна оплаты (не верьте названию! это не фастчекаут) */
    FAST_CHECKOUT_SHOWN = 'FAST_CHECKOUT_SHOWN',
    /** Клик по покупке тарифа в чекаут окне */
    TARIFF_BUY = 'TARIFF_BUY',
    /** Закрытие окна оплаты */
    TARIFF_CLOSE = 'TARIFF_CLOSE',
    /** Клик по стрелочке "назад" */
    TARIFF_BACK_CLICK = 'TARIFF_BACK_CLICK',

    /**
     * @description Клик по покупке тарифа в окне оплаты триала
     */
    TRIAL_TARIFF_BUY = 'TRIAL_TARIFF_BUY',
    /** Показ окна оплаты триала */
    TRIAL_TARIFF_SHOW = 'TRIAL_TARIFF_SHOW',

    /** Модалка "Файл слишком тяжёлый": открытие */
    BIG_FILE_DIALOG_SHOW = 'BIG_FILE_DIALOG_SHOW',
    /** Модалка "Файл слишком тяжёлый": закрытие по крестику */
    BIG_FILE_DIALOG_CLOSE = 'BIG_FILE_DIALOG_CLOSE',
    /** Модалка "Файл слишком тяжёлый": скип */
    BIG_FILE_DIALOG_CANCEL = 'BIG_FILE_DIALOG_CANCEL',
    /** Модалка "Файл слишком тяжёлый": открытие окна покупки подписки */
    BIG_FILE_DIALOG_PAYMENT_SHOW = 'BIG_FILE_DIALOG_PAYMENT_SHOW',
    /** Модалка "Файл слишком тяжёлый": покупка подписки */
    BIG_FILE_DIALOG_PAYMENT_BUY = 'BIG_FILE_DIALOG_PAYMENT_BUY',
    /** Модалка "Файл слишком тяжёлый": клик на кнопку */
    BIG_FILE_DIALOG_CLICK = 'BIG_FILE_DIALOG_CLICK',

    /** Модалка "Файл слишком тяжёлый": клик в "Купить за N р" */
    /* tempexp_18869-next-line tempexp_18955-next-line */
    BIG_FILE_CLICK_BUY_ONCE = 'BIG_FILE_CLICK_BUY_ONCE',

    // Промо триала Mail Space в просмотрщике: показ
    MAIL_SPACE_TRIAL_PROMO_SHOW = 'MAIL_SPACE_TRIAL_PROMO_SHOW',
    // Промо триала Mail Space в просмотрщике: клик
    MAIL_SPACE_TRIAL_PROMO_CLICK = 'MAIL_SPACE_TRIAL_PROMO_CLICK',
    // Промо триала Mail Space в просмотрщике: закрытие
    MAIL_SPACE_TRIAL_PROMO_CLOSE = 'MAIL_SPACE_TRIAL_PROMO_CLOSE',
    /** Модалка почтовых аттачей в облаке: показ */
    MAIL_POPUP_SHOW = 'MAIL_POPUP_SHOW',
    /** Модалка почтовых аттачей в облаке: нажатие на кнопку */
    MAIL_POPUP_CLICK = 'MAIL_POPUP_CLICK',
    /** Модалка почтовых аттачей в облаке: показ оплаты */
    MAIL_POPUP_PAYMENT_SHOW = 'MAIL_POPUP_PAYMENT_SHOW',
    /** Модалка почтовых аттачей в облаке: успешная покупка подписки */
    MAIL_POPUP_PAYMENT_SUCCESS = 'MAIL_POPUP_PAYMENT_SUCCESS',
    /** Модалка почтовых аттачей в облаке: ошибка покупка подписки */
    MAIL_POPUP_PAYMENT_FAILURE = 'MAIL_POPUP_PAYMENT_FAILURE',

    /** Просмотршик файлов. Кнопка закрыть. Клик */
    VIEWER_CLOSE = 'VIEWER_CLOSE',

    /** Кнопка отключения рекламы: показ */
    DISABLE_BUTTON_SHOW = 'DISABLE_BUTTON_SHOW',
    /** Кнопка отключения рекламы: клик */
    DISABLE_BUTTON_CLICK = 'DISABLE_BUTTON_CLICK',
    /** Кнопка отключения рекламы: открытие окна оплаты */
    DISABLE_BUTTON_SHOW_CHECKOUT = 'DISABLE_BUTTON_SHOW_CHECKOUT',
    /**  Кнопка отключения рекламы: оплата */
    DISABLE_BUTTON_PAYMENT = 'DISABLE_BUTTON_PAYMENT',

    /** Промо триала в сайдбаре: показ */
    SIDEBAR_TRIAL_PROMO_SHOW = 'SIDEBAR_TRIAL_PROMO_SHOW',
    /** Промо триала в сайдбаре: закрытие */
    SIDEBAR_TRIAL_PROMO_CLOSE = 'SIDEBAR_TRIAL_PROMO_CLOSE',
    /** Промо триала в сайдбаре: клик */
    SIDEBAR_TRIAL_PROMO_CLICK = 'SIDEBAR_TRIAL_PROMO_CLICK',
    /** Промо триала в сайдбаре: показ */
    SIDEBAR_TRIAL_BANNER_SHOW = 'SIDEBAR_TRIAL_BANNER_SHOW',
    /** Промо триала в сайдбаре: клик */
    SIDEBAR_TRIAL_BANNER_CLICK = 'SIDEBAR_TRIAL_BANNER_CLICK',
    /** Тултип виджета квот: показ */
    QUOTA_TOOLTIP_SHOW = 'QUOTA_TOOLTIP_SHOW',
    /** Тултип виджета квот: закрытие */
    QUOTA_TOOLTIP_CLOSE = 'QUOTA_TOOLTIP_CLOSE',
    /** Кнопка виджета квот со скидкой: показ */
    QUOTA_BUTTON_SHOW = 'QUOTA_BUTTON_SHOW',
    /** Кнопка виджета квот со скидкой: нажатие */
    QUOTA_BUTTON_CLICK = 'QUOTA_BUTTON_CLICK',

    /** Показ фастчекаута (BUY iframe) */
    BUY_FAST_CHECKOUT_VIEW = 'BUY_FAST_CHECKOUT_VIEW',
    /** Нажал кнопку купить на странице фастчекаута (BUY iframe) */
    BUY_FAST_CHECKOUT_CLICK_PAY = 'BUY_FAST_CHECKOUT_CLICK_PAY',
    /** Закрыл фастчекаут (BUY iframe) */
    BUY_FAST_CHECKOUT_CLOSE = 'BUY_FAST_CHECKOUT_CLOSE',
    /** Нажал стрелку назад в фастчекауте (BUY iframe) */
    BUY_FAST_CHECKOUT_BACK = 'BUY_FAST_CHECKOUT_BACK',

    // tempexp_17127-start
    /** Окрытие модального окна (buy-disable-ads iframe) */
    BUY_DISABLE_ADS_MODAL_SHOWN = 'BUY_DISABLE_ADS_MODAL_SHOWN',
    /** Смена периода год / месяц (buy-disable-ads iframe) */
    BUY_DISABLE_ADS_MODAL_PERIOD_CHANGE = 'BUY_DISABLE_ADS_MODAL_PERIOD_CHANGE',
    /** Клик по тарифу (buy-disable-ads iframe) */
    BUY_DISABLE_ADS_MODAL_TARIFF_CLICK = 'BUY_DISABLE_ADS_MODAL_TARIFF_CLICK',
    // tempexp_17127-end

    /** Клик по кнопке шаринга папки (соответствует datalist_item_click_publish) */
    DATALIST_ITEM_CLICK_PUBLISH = 'DATALIST_ITEM_CLICK_PUBLISH',

    /**  Тултип CLOUDWEB-17237: Показ тултипа с "попробовать за 1 р" */
    NICE_LINK_TOOLTIP_SHOW = 'NICE_LINK_TOOLTIP_SHOW',
    /**  Тултип CLOUDWEB-17237: Клик на крестик */
    NICE_LINK_TOOLTIP_CLOSE = 'NICE_LINK_TOOLTIP_CLOSE',
    /**  Тултип CLOUDWEB-17237: Клик на "попробовать за 1 р" */
    NICE_LINK_TOOLTIP_CLICK = 'NICE_LINK_TOOLTIP_CLICK',
    /**  Тултип CLOUDWEB-17237: Показ тултипа "спасибо за интерес" */
    NICE_LINK_THANKS_TOOLTIP_SHOW = 'NICE_LINK_THANKS_TOOLTIP_SHOW',
    /**  Тултип CLOUDWEB-17237: Показ тултипа с "попробовать за 1 р" */
    NICE_LINK_THANKS_TOOLTIP_CLICK = 'NICE_LINK_THANKS_TOOLTIP_CLICK',
    // tempexp_17086-start
    /** Показа сплэша выбора дефолтного тарифа */
    WELCOME_DEFAULT_TARIFFS_SHOW = 'WELCOME_DEFAULT_TARIFFS_SHOW',
    /** Клик по бесплатному тарифу на сплэше выбоа дефолтного тарифа */
    WELCOME_DEFAULT_TARIFFS_CLICK_FREE = 'WELCOME_DEFAULT_TARIFFS_CLICK_FREE',
    // tempexp_17086-end

    /** Модалка оверквоты: показ */
    OVERQUOTA_POPUP_SHOW = 'OVERQUOTA_POPUP_SHOW',
    /** Модалка оверквоты: клик по тарифу */
    OVERQUOTA_POPUP_CLICK = 'OVERQUOTA_POPUP_CLICK',
    /** Показ блока квоты когда юзер в оверквоте */
    QUOTA_BLOCK_OVER_VIEW = 'QUOTA_BLOCK_OVER_VIEW',
    /** Клик по кнопке Увеличить место когда юзер в оверквоте */
    QUOTA_BLOCK_OVER_CLICK = 'QUOTA_BLOCK_OVER_CLICK',
    /** Клик по кнопке Увеличить место (обычный юзер) */
    QUOTA_BLOCK_SPACE_BUTTON_CLICK = 'QUOTA_BLOCK_SPACE_BUTTON_CLICK',
    /** Показ кнопки Увеличить место (обычный юзер) */
    QUOTA_BLOCK_SPACE_BUTTON_VIEW = 'QUOTA_BLOCK_SPACE_BUTTON_VIEW',
    /** Клик по кнопке Увеличить место (обычный юзер) */
    QUOTA_BLOCK_MENU_CLICK = 'QUOTA_BLOCK_MENU_CLICK',

    // tempexp_17125-start
    /** Показ попапа бесплатным оверквотерам при заходе */
    BLOCK_OVERQUOTA_VIEW = 'BLOCK_OVERQUOTA_VIEW',
    /** Клик по кнопке увеличить место в попапе для бесплатных оверквотеров */
    BLOCK_OVERQUOTA_CLICK = 'BLOCK_OVERQUOTA_CLICK',
    /** Показ попапа блокировки просмотра файлов для бесплатных оверквотеров */
    BLOCK_OVERQUOTA_FILES_VIEW = 'BLOCK_OVERQUOTA_FILES_VIEW',
    /** Клик по кнопке увеличить место в попапе блокировки просмотра файлов для бесплатных оверквотеров */
    BLOCK_OVERQUOTA_FILES_CLICK = 'BLOCK_OVERQUOTA_FILES_CLICK',
    // tempexp_17125-end

    // tempexp_17324-start
    MODAL_CHOOSE_TARIFF_SHOW = 'MODAL_CHOOSE_TARIFF_SHOW',
    MODAL_CHOOSE_TARIFF_CONTINUE = 'MODAL_CHOOSE_TARIFF_CONTINUE',
    // tempexp_17324-end

    // tempexp_17509-start
    /** Показ блока "Бонус: 2 месяца подписки" */
    LITRES_PROMO_SHOW = 'LITRES_PROMO_SHOW',
    /** Показ тултипа Литрес */
    LITRES_PROMO_TOOLTIP_SHOW = 'LITRES_PROMO_TOOLTIP_SHOW',
    /** Клик подробнее на тултипе Литрес */
    LITRES_PROMO_TOOLTIP_CLICK = 'LITRES_PROMO_TOOLTIP_CLICK',
    /** Клик подробнее на тултипе Литрес */
    LITRES_PROMO_TOOLTIP_CLOSE = 'LITRES_PROMO_TOOLTIP_CLOSE',
    /** Показ модального окна "Промокод Литрес уже у вас в почте" */
    LITRES_PROMO_SUCCESS_SHOW = 'LITRES_PROMO_SUCCESS_SHOW',
    /** Клик на "Проверить почту" модального окна "Промокод Литрес уже у вас в почте" */
    LITRES_PROMO_SUCCESS_CLICK_CHECK = 'LITRES_PROMO_SUCCESS_CLICK_CHECK',
    /** Клик на "Активирую позже" модального окна "Промокод Литрес уже у вас в почте" */
    LITRES_PROMO_SUCCESS_CLICK_LATER = 'LITRES_PROMO_SUCCESS_CLICK_LATER',
    /** Закрытие модального окна "Промокод Литрес уже у вас в почте" */
    LITRES_PROMO_SUCCESS_CLOSE = 'LITRES_PROMO_SUCCESS_CLOSE',
    // tempexp_17509-end

    // tempexp_17532-start
    /** Показ модального окна с промо Литрес в Облаке */
    LITRES_MODAL_CLOUD_SHOW = 'LITRES_MODAL_CLOUD_SHOW',
    /** Клик на "Выбрать тариф" модального окна с промо Литрес в Облаке */
    LITRES_MODAL_CLOUD_CLICK = 'LITRES_MODAL_CLOUD_CLICK',
    /** Клик на "Неинтересно" модального окна с промо Литрес в Облаке */
    LITRES_MODAL_CLOUD_CANCEL = 'LITRES_MODAL_CLOUD_CANCEL',
    /** Закрытие модального окна с промо Литрес в Облаке */
    LITRES_MODAL_CLOUD_CLOSE = 'LITRES_MODAL_CLOUD_CLOSE',
    // tempexp_17532-end

    /** Показ приветственного попапа с подпиской mailspace*/
    POPUP_BANNER_OFFER_SHOW = 'POPUP_OFFER_SHOW',
    /** Клик на CTA в приветственном попапе с подпиской mailspace*/
    POPUP_BANNER_OFFER_CLICK = 'POPUP_OFFER_CLICK',
    /** Закрытие приветственного попапа с подпиской mailspace*/
    POPUP_BANNER_OFFER_CLOSE = 'POPUP_OFFER_CLOSE',
    /** Покупка из приветственного попапа с подпиской mailspace*/
    POPUP_BANNER_OFFER_BUY = 'POPUP_OFFER_BUY',

    // tempexp_17324-start

    /** Увидел тултип "Выбирайте оформление для папок */
    TOOLTIP_BRAND_PAGE_SHOW = 'TOOLTIP_BRAND_PAGE_SHOW',
    /** Клик на "Попробовать" в тултипе "Выбирайте оформление для папок" */
    TOOLTIP_BRAND_PAGE_CLICK = 'TOOLTIP_BRAND_PAGE_CLICK',
    /** Закрытие тултипа "Выбирайте оформление для папок" */
    TOOLTIP_BRAND_PAGE_CLOSE = 'TOOLTIP_BRAND_PAGE_CLOSE',

    /** Увидели Три точки (Хомяк) */
    BREADCRUMBS_SHOW = 'BREADCRUMBS_SHOW',

    /** Увидели "Выбрать оформление" после нажатия на три точки */
    TOOLBAR_ITEM_SHOW_BRAND_PAGE = 'TOOLBAR_ITEM_SHOW_BRAND_PAGE',
    /** Кликнули "Выбрать оформление" после нажатия на три точки */
    TOOLBAR_ITEM_CLICK_BRAND_PAGE = 'TOOLBAR_ITEM_CLICK_BRAND_PAGE',
    /** Настройка совместого доступа - клик */
    BREADCRUMBS_PUBLISH_CLICK = 'BREADCRUMBS_PUBLISH_CLICK',

    /** Настройка совместого доступа. Увидели пункт Оформление для папки */
    SHARING_BRAND_PAGE_SHOW = 'SHARING_BRAND_PAGE_SHOW',
    /** Настройка совместого доступа. Кликнули "Выбрать" в пункте Оформление для папки */
    SHARING_BRAND_PAGE_CLICK = 'SHARING_BRAND_PAGE_CLICK',

    /** Настройка совместого доступа. Увидели тултип */
    SHARING_TOOLTIP_BRAND_PAGE_SHOW = 'SHARING_TOOLTIP_BRAND_PAGE_SHOW',
    /** Настройка совместого доступа. Закрыли тултип */
    SHARING_TOOLTIP_BRAND_PAGE_CLOSE = 'SHARING_TOOLTIP_BRAND_PAGE_CLOSE',

    /** Увидели Выбрать оформление */
    TOOLBAR_BRAND_PAGE_SHOW = 'TOOLBAR_BRAND_PAGE_SHOW',
    /** Нажали на Выбрать оформление */
    TOOLBAR_BRAND_PAGE_CLICK = 'TOOLBAR_BRAND_PAGE_CLICK',

    /** Попали на страницу брендирования */
    BRAND_PAGE_VIEW = 'BRAND_PAGE_VIEW',
    /** Попали на страницу брендирования */
    BRAND_PAGE_SAVE = 'BRAND_PAGE_SAVE',

    /** Видим модальное окно с тарифами Брендирования */
    BRAND_PAGE_TARIFF_PLAN_CHOOSE = 'BRAND_PAGE_TARIFF_PLAN_CHOOSE',
    /** Клик на тариф в модальном окне Брендирования */
    BRAND_PAGE_TARIFF_CLICK = 'BRAND_PAGE_TARIFF_CLICK',
    /** Нажимаем Свернуть на страницу брендирования */
    BRAND_PAGE_HIDE = 'BRAND_PAGE_HIDE',

    /** Видим модальное окно "Сохранить измененения?" */
    BRAND_PAGE_EXIT_SHOW = 'BRAND_PAGE_EXIT_SHOW',
    /** модальное окно "Сохранить измененения?" - Клик "Выбрать тариф" */
    BRAND_PAGE_EXIT_CHOOSE = 'BRAND_PAGE_EXIT_CHOOSE',
    /** модальное окно "Сохранить измененения?" - Клик "Не сохранять" */
    BRAND_PAGE_EXIT_TRUE = 'BRAND_PAGE_EXIT_TRUE',

    /** Видим промо-бабл */
    BRAND_PUBLIC_PROMO_SHOW = 'BRAND_PUBLIC_PROMO_SHOW',
    /** Клик по кнопке в промо-бабле */
    BRAND_PUBLIC_PROMO_CLICK = 'BRAND_PUBLIC_PROMO_CLICK',
    /** Закрыть промо-бабл */
    BRAND_PUBLIC_PROMO_CLOSE = 'BRAND_PUBLIC_PROMO_CLOSE',

    // tempexp_17324-end

    /** Показ приветственного баннера с увеличением квоты */
    WELCOME_TRIAL_BANNER_SHOW = 'WELCOME_TRIAL_SHOW',
    /** Клик на CTA в пприветственном баннере с увеличением квоты */
    WELCOME_TRIAL_BANNER_CLICK = 'WELCOME_TRIAL_CLICK',
    /** Покупка из приветственного баннера с увеличением квоты*/
    WELCOME_TRIAL_BANNER_BUY = 'WELCOME_TRIAL_BUY',

    /** Показ поля "Пароль для папки" в совместном доступе */
    PUBLIC_PASSWORD_SHOW = 'PUBLIC_PSWD_SHOW',
    /** Клик "Пароль для папки" в совместном доступе */
    PUBLIC_PASSWORD_CLICK = 'PUBLIC_PASSWORD_CLICK',
    /** Клик на "Установить" в поле "Пароль для папки"  в совместном доступе */
    PUBLIC_PASSWORD_SET = 'PUBLIC_PSWD_SET',
    /** Клик на "Сохранить" при установке пароля */
    PUBLIC_PASSWORD_SAVE = 'PUBLIC_PSWD_SAVE',
    /** Показ тултипа "Пароль - с подпиской Mail Space" */
    PUBLIC_PASSWORD_PROMO_SHOW = 'PUBLIC_PSWD_PROMO_SHOW',
    /** Клик на попробовать в тултипе "Пароль - с подпиской Mail Space" */
    PUBLIC_PASSWORD_PROMO_CLICK = 'PUBLIC_PSWD_PROMO_CLICK',
    /** Показ модалки "Файлы защищены паролем" */
    PUBLIC_PASSWORD_GUEST_SHOW = 'PUBLIC_PSWD_GUEST_SHOW',
    /** Показ надписи "Неверный пароль" */
    PUBLIC_PASSWORD_GUEST_INCORRECT = 'PUBLIC_PSWD_GUEST_INCORRECT',
    /** Открытие папки после введения верного пароля */
    PUBLIC_PASSWORD_GUEST_SUCCESS = 'PUBLIC_PSWD_GUEST_SUCCESS',

    // tempexp_17825-start
    /** Клик на карандаш 'изменить карту' в сайдбаре */
    CARD_EDIT_SIDEBAR = 'CARD_EDIT_SIDEBAR',
    /** Клик на крестик 'удаление карты' в сайдбаре */
    CARD_REMOVE_SIDEBAR = 'CARD_REMOVE_SIDEBAR',
    /** Клик "Удалить" в окне "Без карты подписка не продлится" */
    CARD_REMOVE_CONFIRM = 'CARD_REMOVE_CONFIRM',
    // tempexp_17825-end

    /** Показ модалки "Вам скидка навсегда */
    MY_TARIFF_CANCEL_SALE_SHOW = 'MY_TARIFF_CANCEL_SALE_SHOW',
    /** Клик на "Получить скидку" в модалке "Вам скидка навсегда" */
    MY_TARIFF_CANCEL_SALE_GET = 'MY_TARIFF_CANCEL_SALE_GET',
    /** Клик на "Все равно отключить" в модалке "Вам скидка навсегда" */
    MY_TARIFF_CANCEL_SALE_REJECT = 'MY_TARIFF_CANCEL_SALE_REJECT',
    /** Закрытие модалки "Вам скидка навсегда */
    MY_TARIFF_CANCEL_SALE_CLOSE = 'MY_TARIFF_CANCEL_SALE_CLOSE',

    /** Получен статус 202 при попытке открытия окна оплаты */
    STATUS_202_ON_BUY_SUBSCRIPTION = 'STATUS_202_ON_BUY_SUBSCRIPTION',
    /** Показан модальник с предупреждением о повторной оплате */
    REPEAT_PURCHASE_MOBILE_SHOW = 'REPEAT_PURCHASE_MOBILE_SHOW',
    /** Нажали "продолжить оплату" на  модальнике с предупреждением о повторной оплате */
    REPEAT_PURCHASE_MOBILE_CLICK = 'REPEAT_PURCHASE_MOBILE_CLICK',
    /** Нажали "ой, я случайно" оплату на  модальнике с предупреждением о повторной оплате */
    REPEAT_PURCHASE_MOBILE_CANCEL = 'REPEAT_PURCHASE_MOBILE_CANCEL',
    /** Закрыли  модальнике с предупреждением о повторной оплате */
    REPEAT_PURCHASE_MOBILE_CLOSE = 'REPEAT_PURCHASE_MOBILE_CLOSE',
    /** Вызов ручки /buy – успех */
    BILLING_BUY_TARIFF_SUCCESS = 'BILLING_BUY_TARIFF_SUCCESS',
    /** Вызов ручки /buy – ошибка */
    BILLING_BUY_TARIFF_ERROR = 'BILLING_BUY_TARIFF_ERROR',

    // tempexp_17360-start
    /* Показ окна Апсейл с бонусом (гигабайты или + месяц) */
    UPSALE_BONUS_SHOW = 'UPSALE_BONUS_SHOW',
    // tempexp_17360-end

    // tempexp_18090-start
    TARIFF_POLL_SHOW = 'TARIFF_POLL_SHOW',
    TARIFF_POLL_SUCCESS_SHOW = 'TARIFF_POLL_SUCCESS_SHOW',
    // tempexp_18090-end

    // tempexp_18089-start
    PARTNERS_FAKEDOOR_VIEW = 'PARTNERS_FAKEDOOR_VIEW',
    PARTNERS_FAKEDOOR_MODAL_VIEW = 'PARTNERS_FAKEDOOR_MODAL_VIEW',
    // tempexp_18089-end

    /* Флоу отписки. Показ экрана инфой о тарифе */
    CANCEL_SUB_TARIFF = 'CANCEL_SUB_TARIFF',
    /* Флоу отписки. Показ экрана с капчей */
    CANCEL_SUB_CAPTCHA = 'CANCEL_SUB_CAPTCHA',
    /* Флоу отписки. Успешная отписка (отключение автопродления) */
    CANCEL_SUB_SUCCESS = 'CANCEL_SUB_SUCCESS',
    /* Флоу отписки. Клик на "Отключить" на экране с капчей */
    CANCEL_SUB_CAPTCHA_CANCEL = 'CANCEL_SUB_CAPTCHA_CANCEL',

    // tempexp_17359-start
    /* Флоу отписки. Показ экрана семьи без участников */
    CANCEL_SUB_EMPTY_FAMILY = 'CANCEL_SUB_EMPTY_FAMILY',
    /* Флоу отписки. Экрана семьи с участниками. Клик на кнопку Добавить участников */
    CANCEL_SUB_EMPTY_FAMILY_CLICK = 'CANCEL_SUB_EMPTY_FAMILY_CLICK',
    /* Флоу отписки. Показ экрана семьи с участниками */
    CANCEL_SUB_FAMILY = 'CANCEL_SUB_FAMILY',
    /* Флоу отписки. Экрана семьи с участниками. Клик на кнопку Сохранить подписку */
    CANCEL_SUB_FAMILY_CLICK = 'CANCEL_SUB_FAMILY_CLICK',
    /* Флоу отписки. Экрана семьи с участниками. Клик на кнопку Отключить */
    CANCEL_SUB_FAMILY_CANCEL = 'CANCEL_SUB_FAMILY_CANCEL',
    // tempexp_17359-end

    // tempexp_18238-start
    /** Показ модального окна "Одна цена на четверых" */
    FAMILY_AFTER_PURCHASE_MODAL_SHOW = 'FAMILY_AFTER_PURCHASE_MODAL_SHOW',
    /** Клик на "Добавить участника" в модальном окне */
    FAMILY_AFTER_PURCHASE_MODAL_CLICK = 'FAMILY_AFTER_PURCHASE_MODAL_CLICK',
    /** Клик на "Не сейчас" в модальном окне */
    FAMILY_AFTER_PURCHASE_MODAL_CANCEL = 'FAMILY_AFTER_PURCHASE_MODAL_CANCEL',
    /** Закрытие модалки "Одна цена на четверых" */
    FAMILY_AFTER_PURCHASE_MODAL_CLOSE = 'FAMILY_AFTER_PURCHASE_MODAL_CLOSE',
    /** Показ модального окна "Приглашение в Mail Space" */
    FAMILY_INVITE_LINK_SHOW = 'FAMILY_INVITE_LINK_SHOW',
    /** Клик на "Скопировать" в модальном окне */
    FAMILY_INVITE_LINK_CLICK = 'FAMILY_INVITE_LINK_CLICK',
    /** Закрытие модалки "Приглашение в Mail Space" */
    FAMILY_INVITE_LINK_CLOSE = 'FAMILY_INVITE_LINK_CLOSE',
    // tempexp_18238-end

    /** Получен статус об оплате */
    BEFORE_PURCHASE_MESSAGE_STATUS = 'BEFORE_PURCHASE_MESSAGE_STATUS',
    /** Показан модальник с предупреждением об оплате */
    BEFORE_PURCHASE_MESSAGE_SHOW = 'BEFORE_PURCHASE_MESSAGE_SHOW',
    /** Нажали Ок на  модальнике с предупреждением об оплате */
    BEFORE_PURCHASE_MESSAGE_CLICK = 'BEFORE_PURCHASE_MESSAGE_CLICK',
    /** Закрыли  модальник с предупреждением об оплате */
    BEFORE_PURCHASE_MESSAGE_CLOSE = 'BEFORE_PURCHASE_MESSAGE_CLOSE',

    /** Открытие окна шэринга */
    ENABLE_SHARING_SHOW = 'ENABLE_SHARING_SHOW',
    /** Показ раздела "Расширенные Настройки" Свернутый вид */
    SHARING_ADVANCED_SETTINGS_PUBLIC_HIDDEN = 'SHARING_ADVANCED_SETTINGS_PUBLIC_HIDDEN',
    /** Показ раздела "Расширенные Настройки" Развернутый вид */
    SHARING_ADVANCED_SETTINGS_PUBLIC_SHOW = 'SHARING_ADVANCED_SETTINGS_PUBLIC_SHOW',
    /** Показ кнопки "Подключить за 1р" */
    ONBOARDING_TRIAL_BUTTON_SHOW = 'ONBOARDING_TRIAL_BUTTON_SHOW',
    /** Клик по кнопке "Подключить за 1р"*/
    ONBOARDING_TRIAL_BUTTON_CLICK = 'ONBOARDING_TRIAL_BUTTON_CLICK',
    /** Показ тултипа "С подпиской можно больше" */
    ONBOARDING_TOOLTIP_SHOW = 'ONBOARDING_TOOLTIP_SHOW',
    /** Закрытие тултипа "С подпиской можно больше" */
    ONBOARDING_TOOLTIP_CLOSE = 'ONBOARDING_TOOLTIP_CLOSE',
    /** Показ кнопки "Установить" для Автоудаления паблика */
    ONBOARDING_AUTODELETE_SHOW = 'ONBOARDING_AUTODELETE_SHOW',
    /** Клик кнопки "Установить" для Автоудаления паблика */
    ONBOARDING_AUTODELETE_CLICK = 'ONBOARDING_AUTODELETE_CLICK',

    /** Открытие просмоторщика */
    EDITOR_VIEWER_OPEN = 'EDITOR_VIEWER_OPEN',
    /** Показ кнопки "Редактировать" */
    EDITOR_BUTTON_SHOW = 'EDITOR_BUTTON_SHOW',
    /** Клик на кнопку "Редактировать" */
    EDITOR_BUTTON_CLICK = 'EDITOR_BUTTON_CLICK',
    /** Показ тултипа "Доступно с тарифами от 512 Гб" */
    EDITOR_TOOLTIP_SHOW_512 = 'EDITOR_TOOLTIP_SHOW_512',
    /** Клик на "Увеличить до 512 Гб" */
    EDITOR_TOOLTIP_CLICK_512 = 'EDITOR_TOOLTIP_CLICK_512',
    /** Клик "Другие тарифы" */
    EDITOR_TOOLTIP_CLICK_TARIFF_512 = 'EDITOR_TOOLTIP_CLICK_TARIFF_512',

    /** Открытие файла */
    EDITOR_VIEWER_OPEN_CONTENT = 'EDITOR_VIEWER_OPEN_CONTENT',
    /** Показ балуна "Редактирование в тарифах от 512 Гб" */
    EDITOR_BALLOON_SHOW_512 = 'EDITOR_BALLOON_SHOW_512',
    /** Клик на увеличить до 512 Гб */
    EDITOR_BALLOON_CLICK_512 = 'EDITOR_BALLOON_CLICK_512',
    /** Клик "Другие тарифы" в балуне */
    EDITOR_BALLOON_CLICK_TARIFF_512 = 'EDITOR_BALLOON_CLICK_TARIFF_512',
    /** Закрытие балуна */
    EDITOR_BALLOON_CLOSE_512 = 'EDITOR_BALLOON_CLOSE_512',

    /** Показ шторки "Доступно с тарифом от 512 Гб" */
    EDITOR_SPLASHSCREEN_ALERT_SHOW_512 = 'EDITOR_SPLASHSCREEN_ALERT_SHOW_512',
    /** Клик на увеличить до 512 Гб */
    EDITOR_SPLASHSCREEN_ALERT_CLICK_512 = 'EDITOR_SPLASHSCREEN_ALERT_CLICK_512',
    /** Клик "Другие тарифы" в шторке */
    EDITOR_SPLASHSCREEN_ALERT_CLICK_TARIFF_512 = 'EDITOR_SPLASHSCREEN_ALERT_CLICK_TARIFF_512',
    /** Закрытие шторки */
    EDITOR_SPLASHSCREEN_ALERT_CLOSE_512 = 'EDITOR_SPLASHSCREEN_ALERT_CLOSE_512',

    // tempexp_18683-start
    /** Показ баллуна-промо гибкого расширения квоты */
    FLEXIBLE_QUOTA_PROMO_SHOW = 'FLEXIBLE_QUOTA_PROMO_SHOW',
    /** Клик по кнопке в баллуне-промо гибкого расширения квоты */
    FLEXIBLE_QUOTA_PROMO_CLICK = 'FLEXIBLE_QUOTA_PROMO_CLICK',
    /** Закрытие баллуна-промо гибкого расширения квоты */
    FLEXIBLE_QUOTA_PROMO_CLOSE = 'FLEXIBLE_QUOTA_PROMO_CLOSE',
    /** Показ кнопки на /subs для поднятия окна гибкого расширения квоты */
    FLEXIBLE_QUOTA_BUTTON_SHOW = 'FLEXIBLE_QUOTA_BUTTON_SHOW',
    /** Клик по кнопке */
    FLEXIBLE_QUOTA_BUTTON_CLICK = 'FLEXIBLE_QUOTA_BUTTON_CLICK',
    /** Показ промо-блока гибкого расширения квоты на лендинге Mail Space */
    FLEXIBLE_QUOTA_PROMO_LAND_SHOW = 'FLEXIBLE_QUOTA_PROMO_LAND_SHOW',
    /** Клик по кнопке на промо-блоке гибкого расширения квоты */
    FLEXIBLE_QUOTA_PROMO_LAND_CLICK = 'FLEXIBLE_QUOTA_PROMO_LAND_CLICK',
    /** Открытие модального окна "Увеличение Облака" */
    FLEXIBLE_QUOTA_MODAL_SHOW = 'FLEXIBLE_QUOTA_MODAL_SHOW',
    /** Изменение количества Гб в модальном окне "Увеличение Облака" */
    FLEXIBLE_QUOTA_MODAL_CHANGE = 'FLEXIBLE_QUOTA_MODAL_CHANGE',
    /** Клик на продолжить в модальном окне "Увеличение Облака"  */
    FLEXIBLE_QUOTA_MODAL_CLICK = 'FLEXIBLE_QUOTA_MODAL_CLICK',
    // tempexp_18683-end

    /** Показ балуна с тестом */
    ASIDE_POLL_SHOW = 'ASIDE_POLL_SHOW',
    /** Начало теста */
    ASIDE_POLL_START = 'ASIDE_POLL_START',
    /** Показ результатов теста */
    ASIDE_POLL_RESULTS_SHOW = 'ASIDE_POLL_RESULTS_SHOW',
    /** Клик на кнопку на экране результатов */
    ASIDE_POLL_RESULTS_CLICK = 'ASIDE_POLL_RESULTS_CLICK',

    // tempexp_18696-start
    /** Показ балуна */
    ASIDE_COVERAGE_CAMPAIGN_SHOW = 'ASIDE_COVERAGE_CAMPAIGN_SHOW',
    /** Показ балуна */
    ASIDE_COVERAGE_CAMPAIGN_CLICK = 'ASIDE_COVERAGE_CAMPAIGN_CLICK',
    // tempexp_18696-end

    /** Отток. Показ модалки описания тарифа */
    MY_TARIFF_OPEN = 'MY_TARIFF_OPEN',
    /** Отток. Нажатие на "Отключить автоплатеж" */
    MY_TARIFF_CANCEL_AUTOPAY = 'MY_TARIFF_CANCEL_AUTOPAY',
    /** Отток. Нажатие на "Продлить подписку" */
    MY_TARIFF_PROLONG_SUB = 'MY_TARIFF_PROLONG_SUB',

    /** Отток. Показ опроса. */
    POLL_OPEN = 'POLL_OPEN',
    /** Отток. Отправка результата опроса. */
    POLL_SEND = 'POLL_SEND',

    /** Показ экрана с заголовком "Вы уверены" во флоу отключение автоплатежа */
    MY_TARIFF_CANCEL_AUTOPAY_SHOW = 'MY_TARIFF_CANCEL_AUTOPAY_SHOW',
    /** Отток. Нажатие на "Сохранить подписку" на втором экране */
    MY_TARIFF_CANCEL_AUTOPAY_SAVE = 'MY_TARIFF_CANCEL_AUTOPAY_SAVE',
    /** Отток. Нажатие на "Отключить" на втором экране */
    MY_TARIFF_CANCEL_AUTOPAY_TRUE = 'MY_TARIFF_CANCEL_AUTOPAY_TRUE',

    /** Показ "Если отключить автоплатёж, пропадут сразу два сервиса" */
    VK_MUSIC_TARIFF_CANCEL_VIEW = 'VK_MUSIC_TARIFF_CANCEL_VIEW',
    /** Клик на отключить в "Если отключить автоплатёж, пропадут сразу два сервиса" */
    VK_MUSIC_TARIFF_CANCEL_CANCEL = 'VK_MUSIC_TARIFF_CANCEL_CANCEL',
    /** Клик на "Сохранить два сервиса" в "Если отключить автоплатёж, пропадут сразу два сервиса" */
    VK_MUSIC_TARIFF_CANCEL_SAVE = 'VK_MUSIC_TARIFF_CANCEL_SAVE',

    // tempexp_18851-start
    /** Открытие модалки "У вас была подписка Mail Space" */
    PAID_USER_RETURN_MODAL_SHOW = 'PAID_USER_RETURN_MODAL_SHOW',
    /** Клик на "Забрать со скидкой 512Гб" */
    PAID_USER_RETURN_MODAL_CLICK = 'PAID_USER_RETURN_MODAL_CLICK',
    /** Закрытие модалки*/
    PAID_USER_RETURN_MODAL_CLOSE = 'PAID_USER_RETURN_MODAL_CLOSE',
    // tempexp_18851-end

    /** Предлагать 512 гб, если заполнено 80% квоты */
    /** Показ модалки */
    EXTEND_QUOTA_OFFER_SHOW = 'EXTEND_QUOTA_OFFER_SHOW',
    /** Клик по главному СТА */
    EXTEND_QUOTA_OFFER_PRIMARY_CLICK = 'EXTEND_QUOTA_OFFER_PRIMARY_CLICK',
    /** Клик по второстепенному СТА – переход на страницу тарифов */
    EXTEND_QUOTA_OFFER_SECONDARY_CLICK = 'EXTEND_QUOTA_OFFER_SECONDARY_CLICK',
    /** Закрытие модалки по крестику */
    EXTEND_QUOTA_OFFER_CLOSE = 'EXTEND_QUOTA_OFFER_CLOSE',

    // tempexp_18855-start
    /** Показ модалки */
    CROSS_PROMO_VK_MUSIC_FAKEDOOR_SHOW = 'CROSS_PROMO_VK_MUSIC_FAKEDOOR_SHOW',
    /** Клик на СТА модалки */
    CROSS_PROMO_VK_MUSIC_FAKEDOOR_CLICK = 'CROSS_PROMO_VK_MUSIC_FAKEDOOR_CLICK',
    /** Показ модалки с несколькими подписками */
    CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_SHOW = 'CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_SHOW',
    /** Клик на СТА модалки с несколькими подписками */
    CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_CLICK = 'CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_CLICK',
    // tempexp_18855-end

    // tempexp_18662-start
    /** Показ модального окна со свойствами паблика */
    PUBLIC_INFO_MODAL_SHOW = 'PUBLIC_INFO_MODAL_SHOW',
    /** Показ счетчика скачиваний */
    PUBLIC_INFO_DOWNLOADS = 'PUBLIC_INFO_DOWNLOADS',
    /** Показ счетчика просмотров */
    PUBLIC_INFO_VIEWS = 'PUBLIC_INFO_VIEWS',
    // tempexp_18662-end

    // tempexp_18727-start
    /** Показ модалки с предложением триала на 7 дней при отмене покупки тарифа */
    SKIPPED_PAYMENT_MODAL_7D_SHOW = 'SKIPPED_PAYMENT_MODAL_7D_SHOW',
    /** Клик в модалке с предложением триала на 7 дней при отмене покупки тарифа */
    SKIPPED_PAYMENT_MODAL_7D_CLICK = 'SKIPPED_PAYMENT_MODAL_7D_CLICK',
    /** Показ модалки с предложением триала на 14 дней при отмене покупки тарифа */
    SKIPPED_PAYMENT_MODAL_14D_SHOW = 'SKIPPED_PAYMENT_MODAL_14D_SHOW',
    /** Клик в модалке с предложением триала на 14 дней при отмене покупки тарифа */
    SKIPPED_PAYMENT_MODAL_14D_CLICK = 'SKIPPED_PAYMENT_MODAL_14D_CLICK',
    // tempexp_18727-end

    // tempexp_17847-start
    /** Показ тултипа про лимит скачиваний на шаринге */
    PUBLIC_LIMIT_PROMO_SHARING_SHOW = 'PUBLIC_LIMIT_PROMO_SHARING_SHOW',
    /** Закрытие тултипа про лимит скачиваний на шаринге */
    PUBLIC_LIMIT_PROMO_SHARING_CLOSE = 'PUBLIC_LIMIT_PROMO_SHARING_CLOSE',
    /** Клик на снять лимит скачиваний в тултипе на шаринге */
    PUBLIC_LIMIT_PROMO_SHARING_CLICK = 'PUBLIC_LIMIT_PROMO_SHARING_CLICK',
    /** Показ тултипа про количество скачиваний на списке */
    PUBLIC_LIMIT_PROMO_LIST_SHOW = 'PUBLIC_LIMIT_PROMO_LIST_SHOW',
    /** Закрытие тултипа про количество скачиваний на списке */
    PUBLIC_LIMIT_PROMO_LIST_CLOSE = 'PUBLIC_LIMIT_PROMO_LIST_CLOSE',
    /** Клик на снять лимит скачиваний в тултипе про количество скачиваний на списке */
    PUBLIC_LIMIT_PROMO_LIST_CLICK = 'PUBLIC_LIMIT_PROMO_LIST_CLICK',
    /** Показ тултипа про лимит скачиваний на паблике */
    PUBLIC_LIMIT_PROMO_LINK_SHOW = 'PUBLIC_LIMIT_PROMO_LINK_SHOW',
    /** Закрытие тултипа про лимит скачиваний на паблике */
    PUBLIC_LIMIT_PROMO_LINK_CLOSE = 'PUBLIC_LIMIT_PROMO_LINK_CLOSE',
    /** Клик на снять лимит скачиваний в тултипе на паблике */
    PUBLIC_LIMIT_PROMO_LINK_CLICK = 'PUBLIC_LIMIT_PROMO_LINK_CLICK',
    /** Показ информера о лимите на шаринге */
    INFORMER_SHARING_SHOW = 'INFORMER_SHARING_SHOW',
    /** Клик на снятие лимита в информере на шаринге */
    INFORMER_SHARING_CLICK = 'INFORMER_SHARING_CLICK',
    /** Показ информера о лимите на хомяке */
    INFORMER_HOME_SHOW = 'INFORMER_HOME_SHOW',
    /** Клик на снятие лимита в информере на хомяке */
    INFORMER_HOME_CLICK = 'INFORMER_HOME_CLICK',
    /** Закрытие информера о лимите на хомяке */
    INFORMER_HOME_CLOSE = 'INFORMER_HOME_CLOSE',
    // tempexp_17847-end

    // tempexp_18907-start
    /** Сохранние инфо о скидке в LS */
    DISCOUNT_LS_SAVE = 'DISCOUNT_LS_SAVE',
    /** Очистка инфо о скидке в LS */
    DISCOUNT_LS_CLEAR = 'DISCOUNT_LS_CLEAR',

    /** Показ модалки */
    DISCOUNT_MODAL_SHOW = 'DISCOUNT_MODAL_SHOW',
    /** Клик на "Продлить со скидкой" */
    DISCOUNT_MODAL_CLICK = 'DISCOUNT_MODAL_CLICK',
    /** Закрытие модалки по крестику или нажатию на "Не сейчас" */
    DISCOUNT_MODAL_CANCEL = 'DISCOUNT_MODAL_CANCEL',
    /** Включение автопродления из модалки */
    DISCOUNT_MODAL_ENABLE = 'DISCOUNT_MODAL_ENABLE',

    /** Показ таймера */
    DISCOUNT_TIMER_SHOW = 'DISCOUNT_TIMER_SHOW',
    /** Клик по таймеру */
    DISCOUNT_TIMER_CLICK = 'DISCOUNT_TIMER_CLICK',
    /** Закрытие таймера */
    DISCOUNT_TIMER_CANCEL = 'DISCOUNT_TIMER_CANCEL',
    // tempexp_18907-end
    // tempexp_18086-start
    /** Показ балуна с реферальной программой */
    REFERRAL_BALLON_SHOW = 'REFERRAL_BALLON_SHOW',
    /** Клик на "Рекомендовать" на балуне */
    REFERRAL_BALLON_CLICK = 'REFERRAL_BALLON_CLICK',
    /** Закрытие балуна */
    REFERRAL_BALLON_CLOSE = 'REFERRAL_BALLON_CLOSE',
    /** Показ тултипа с реферальной программой */
    REFERRAL_TOOLTIP_SHOW = 'REFERRAL_TOOLTIP_SHOW',
    /** Клик на "Рекомендовать" в тултипе */
    REFERRAL_TOOLTIP_CLICK = 'REFERRAL_TOOLTIP_CLICK',
    /** Закрытие тултипа */
    REFERRAL_TOOLTIP_CLOSE = 'REFERRAL_TOOLTIP_CLOSE',
    /** Показ брендированной плашки (сайдбар) */
    REFERRAL_BANNER_SHOW = 'REFERRAL_BANNER_SHOW',
    /** Клик на брендированную плашку */
    REFERRAL_BANNER_CLICK = 'REFERRAL_BANNER_CLICK',
    /** Клик на "Бонусы за друзей" в меню */
    REFERRAL_BONUS_SPACE_CLICK = 'REFERRAL_BONUS_SPACE_CLICK',
    /** Показ на сабсе блока рефералки */
    REFERRAL_SUBS_BANNER_SHOW = 'REFERRAL_SUBS_BANNER_SHOW',
    /** Клик блока рефералки */
    REFERRAL_SUBS_BANNER_CLICK = 'REFERRAL_SUBS_BANNER_CLICK',
    /** Показ модалки Бонусы за друзей */
    REFERRAL_BONUS_MODAL_SHOW = 'REFERRAL_BONUS_MODAL_SHOW',
    /** Копировать ссылку с модалки Бонусы за друзей */
    REFERRAL_BONUS_MODAL_COPY = 'REFERRAL_BONUS_MODAL_COPY',
    /** Клик модалки Бонусы за друзей */
    REFERRAL_BONUS_MODAL_CLICK = 'REFERRAL_BONUS_MODAL_CLICK',
    /** Закрытие модалки Бонусы за друзей */
    REFERRAL_BONUS_MODAL_CLOSE = 'REFERRAL_BONUS_MODAL_CLOSE',
    /** Показ информации про бонус */
    REFERRAL_BONUS_INFO_SHOW = 'REFERRAL_BONUS_INFO_SHOW',
    /** Закрытие информации про бонус */
    REFERRAL_BONUS_INFO_CLOSE = 'REFERRAL_BONUS_INFO_CLOSE',
    /** Показ модалки "Забрать скидку не получается" */
    REFERRAL_FAILED_MODAL_SHOW = 'REFERRAL_FAILED_MODAL_SHOW',
    /** Клик модалки "Забрать скидку не получается" */
    REFERRAL_FAILED_MODAL_CLICK = 'REFERRAL_FAILED_MODAL_CLICK',
    /** Закрытие модалки "Забрать скидку не получается" */
    REFERRAL_FAILED_MODAL_CLOSE = 'REFERRAL_FAILED_MODAL_CLOSE',
    // tempexp_18086-end

    // tempexp_18926-start
    /** Показ модалки Онбординга автозагрузки */
    AUTOUPLOAD_ONBOARDING_SHOW = 'AUTOUPLOAD_ONBOARDING_SHOW',
    /** Клик в модалке Онбординга автозагрузки */
    AUTOUPLOAD_ONBOARDING_CLICK = 'AUTOUPLOAD_ONBOARDING_CLICK',
    /** Показ модалки 2 шага Онбординга автозагрузки */
    AUTOUPLOAD_ONBOARDING_FINAL_SHOW = 'AUTOUPLOAD_ONBOARDING_FINAL_SHOW',
    /** Клик в модалке 2 шага Онбординга автозагрузки */
    AUTOUPLOAD_ONBOARDING_FINAL_CLICK = 'AUTOUPLOAD_ONBOARDING_FINAL_CLICK',
    /** Показ модалки отмемены подписки с автозагрузкой */
    AUTOUPLOAD_CANCEL_SHOW = 'AUTOUPLOAD_CANCEL_SHOW',
    /** Клик Сохранить подписку в модалке отмемены подписки с автозагрузкой */
    AUTOUPLOAD_CANCEL_SAVE = 'AUTOUPLOAD_CANCEL_SAVE',
    /** Клик Отменить подписку в модалке отмемены подписки с автозагрузкой */
    AUTOUPLOAD_CANCEL = 'AUTOUPLOAD_CANCEL',
    // tempexp_18926-end

    // tempexp_19300-start
    DISCOUNT_ON_REMOVE_MODAL_SHOW = 'DISCOUNT_ON_REMOVE_MODAL_SHOW',
    DISCOUNT_ON_REMOVE_MODAL_CLICK = 'DISCOUNT_ON_REMOVE_MODAL_CLICK',
    DISCOUNT_ON_REMOVE_MODAL_CANCEL = 'DISCOUNT_ON_REMOVE_MODAL_CANCEL',
    DISCOUNT_ON_REMOVE_MODAL_CLOSE = 'DISCOUNT_ON_REMOVE_MODAL_CLOSE',
    // tempexp_19300-end

    /* Интеграция с VK Музыкой */

    /** Модалка с оффером бандла */
    VK_MUSIC_OFFER_SHOW = 'VK_MUSIC_OFFER_SHOW',
    VK_MUSIC_OFFER_CLICK = 'VK_MUSIC_OFFER_CLICK',
    VK_MUSIC_OFFER_CLOSE = 'VK_MUSIC_OFFER_CLOSE',

    /** Модалка подтверждения VKID */
    VK_MUSIC_CONFIRM_SHOW = 'VK_MUSIC_CONFIRM_SHOW',
    VK_MUSIC_CONFIRM_CONTINUE = 'VK_MUSIC_CONFIRM_CONTINUE',
    VK_MUSIC_CONFIRM_CHOOSE = 'VK_MUSIC_CONFIRM_CHOOSE',
    VK_MUSIC_CONFIRM_CLOSE = 'VK_MUSIC_CONFIRM_CLOSE',

    /** Модалка ошибки */
    VK_MUSIC_ERROR_SHOW = 'VK_MUSIC_ERROR_SHOW',
    VK_MUSIC_ERROR_BUY = 'VK_MUSIC_ERROR_BUY',
    VK_MUSIC_ERROR_CHOOSE = 'VK_MUSIC_ERROR_CHOOSE',
    VK_MUSIC_ERROR_CLOSE = 'VK_MUSIC_ERROR_CLOSE',

    /** Модалка успеха */
    VK_MUSIC_SUCCESS_SHOW = 'VK_MUSIC_SUCCESS_SHOW',
    VK_MUSIC_SUCCESS_CLICK = 'VK_MUSIC_SUCCESS_CLICK',
    VK_MUSIC_SUCCESS_CLOSE = 'VK_MUSIC_SUCCESS_CLOSE',

    /** Баннер на лендинге */
    VK_MUSIC_OFFER_LANDING_VIEW = 'VK_MUSIC_OFFER_LANDING_VIEW',
    VK_MUSIC_OFFER_LANDING_CLICK = 'VK_MUSIC_OFFER_LANDING_CLICK',

    PAUSE_SUBS_SHOW = 'PAUSE_SUBS_SHOW',
    PAUSE_SUBS_CLICK = 'PAUSE_SUBS_CLICK',
    PAUSE_SUBS_CANCEL = 'PAUSE_SUBS_CANCEL',

    /* Интеграция с VK Музыкой */

    // tempexp_19232-start
    /** Показ кнопки покупки тарифа над списком тарифов */
    MAY_PROMO_2025_BUY_TARIFF_SHOW = 'MAY_PROMO_2025_BUY_TARIFF_SHOW',
    /** Клик на кнопку покупки тарифа над списком тарифов */
    MAY_PROMO_2025_BUY_TARIFF_CLICK = 'MAY_PROMO_2025_BUY_TARIFF_CLICK',
    // tempexp_19232-end

    // tempexp_19370-start
    /** показ попапа о приоритетном скачивании */
    PRIORITY_DOWNLOAD_SHOW = 'PRIORITY_DOWNLOAD_SHOW',
    /** переход по кнопке "не хочу ждать" в попапе о приоритетном скачивании */
    PRIORITY_DOWNLOAD_CLICK = 'PRIORITY_DOWNLOAD_CLICK',
    // tempexp_19370-end

    // tempexp_19094-start
    /** Показ фуллскрина подписки */
    FULLSCREEN_SHOW = 'FULLSCREEN_SHOW',
    /** Клик по кнопке фуллскрина */
    FULLSCREEN_CLICK = 'FULLSCREEN_CLICK',
    /** Клик по фуллскрину */
    FULLSCREEN_CLICK_ALL = 'FULLSCREEN_CLICK_ALL',
    /** Закрытие фуллскрина */
    FULLSCREEN_CLOSE = 'FULLSCREEN_CLOSE',
    // tempexp_19094-end

    /** Смена линейки тарифов в мультарифах (мобилка)  */
    MULTITARIFF_TYPE_CLICK_M = 'MULTITARIFF_TYPE_CLICK_M',
    /** Смена размера тарифов в мультарифах (мобилка)  */
    MULTITARIFF_SIZE_CLICK_M = 'MULTITARIFF_SIZE_CLICK_M',

    // tempexp_19373-start
    /** Показ модалки красивого адреса */
    BEAUTIFUL_ADDRESS_MODAL_SHOW = 'BEAUTIFUL_ADDRESS_MODAL_SHOW',
    /** Клик по Выбрать тариф */
    BEAUTIFUL_ADDRESS_MODAL_CLICK = 'BEAUTIFUL_ADDRESS_MODAL_CLICK',
    /** Закрытие модалки красивого адреса */
    BEAUTIFUL_ADDRESS_MODAL_CLOSE = 'BEAUTIFUL_ADDRESS_MODAL_CLOSE',
    // tempexp_19373-end

    // tempexp_19420-start
    /** Клик по кнопке переименования файла в редакторе документов */
    EDITOR_TOOLS_RENAME_CLICK = 'EDITOR_TOOLS_RENAME_CLICK',
    /** Клик по кнопке отправки файла письмом в редакторе документов */
    EDITOR_TOOLS_SEND_ATTACH_CLICK = 'EDITOR_TOOLS_SEND_ATTACH_CLICK',
    // tempexp_19420-end

    // tempexp_19513-start
    /** Показ апсейла в мультитарифах */
    UPSALE_MULTI_MODAL_SHOW = 'UPSALE_MULTI_MODAL_SHOW',
    /** Переключение тарифов в модалке */
    UPSALE_MULTI_MODAL_SWITCH = 'UPSALE_MULTI_MODAL_SWITCH',
    /** Клик Продолжить */
    UPSALE_MULTI_MODAL__CONTINUE = 'UPSALE_MULTI_MODAL__CONTINUE',
    /** Закрытие диалога/модалки */
    UPSALE_MULTI_MODAL_CLOSE = 'UPSALE_MULTI_MODAL_CLOSE',
    // tempexp_19513-end

    // tempexp_19617-start
    /** Модалка фейкдор */
    UNLIMITED_DOCUMENTS_MODAL_SHOW = 'UNLIMITED_DOCUMENTS_MODAL_SHOW',
    UNLIMITED_DOCUMENTS_MODAL_CLICK = 'UNLIMITED_DOCUMENTS_MODAL_CLICK',
    UNLIMITED_DOCUMENTS_MODAL_CLOSE = 'UNLIMITED_DOCUMENTS_MODAL_CLOSE',

    /** Модалка "Спасибо за внимание"  */
    UNLIMITED_DOCUMENTS_THANKS_MODAL_SHOW = 'UNLIMITED_DOCUMENTS_THANKS_MODAL_SHOW',
    UNLIMITED_DOCUMENTS_THANKS_MODAL_CLICK = 'UNLIMITED_DOCUMENTS_THANKS_MODAL_CLICK',
    UNLIMITED_DOCUMENTS_THANKS_MODAL_CLOSE = 'UNLIMITED_DOCUMENTS_THANKS_MODAL_CLOSE',

    /** Баннер-промо в левом нижнем углу  */
    UNLIMITED_DOCUMENTS_ASIDE_BANNER_SHOW = 'UNLIMITED_DOCUMENTS_ASIDE_BANNER_SHOW',
    UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLICK = 'UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLICK',
    UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLOSE = 'UNLIMITED_DOCUMENTS_ASIDE_BANNER_CLOSE',

    /** Баннер под блоком квоты  */
    UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_SHOW = 'UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_SHOW',
    UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_CLICK = 'UNLIMITED_DOCUMENTS_SIDEBAR_BANNER_CLICK',
    // tempexp_19617-end
}
